import { render, staticRenderFns } from "./CompOrg.vue?vue&type=template&id=b04b7c7a&"
import script from "./CompOrg.vue?vue&type=script&lang=js&"
export * from "./CompOrg.vue?vue&type=script&lang=js&"
import style0 from "./CompOrg.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports